import React, { Component } from "react";
import { Modal, Form, Row, Col, Button, Select } from "antd";
import InputForm from "./InputForm";
import { checkFormIsValid } from '../utils/Validator';
import "./Form.css";

const { Item: ItemForm } = Form;

export const OPCOES_COR = [
  { key: '#FFFFFF', label: 'BRANCO', color: '#FFFFFF' },
  { key: '#E6E6E6', label: 'CINZA', color: '#E6E6E6' },
  { key: '#CEECF5', label: 'AZUL', color: '#CEECF5' },
  { key: '#81F7F3', label: 'CIAN', color: '#81F7F3' },
  { key: '#A9F5BC', label: 'VERDE', color: '#A9F5BC' },
  { key: '#F5A9A9', label: 'VERMELHO', color: '#F5A9A9' },
  { key: '#F5DA81', label: 'LARANJA', color: '#F5DA81' },
  { key: '#F5F6CE', label: 'AMARELO', color: '#F5F6CE' },
]


export default class CategoriaAnaliseProducaoForm extends Component {
  state = {
    registro: {
      cap_idf: '',
      cap_descricao: '',
      cap_cor: { key: '#FFFFFF', label: "" }
    },
    cap_cor: { key: '#FFFFFF', label: "" }
  };


  componentDidUpdate(propsAnterior, stateAnterior) {
    if (this.props.registroSelecionado !== propsAnterior.registroSelecionado) {
      this.setState({
        registro: this.props.registroSelecionado,
        cap_cor: { key: this.props.registroSelecionado.cap_cor.key, label: "" }
      }, () => {
        this.refs.cap_descricao.focus();
      });
    }
  }

  onChange = event => {
    const value = event.target.value;
    const id = event.target.id;

    const { registro } = this.state;
    registro[id] = value;

    this.setState({
      [id]: value
    });
  };

  onOK = () => {
    if ((!this.state.registro.cap_descricao) || (this.state.registro.cap_descricao === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe a Descrição' });
      return;
    }
    if (!this.state.registro.cap_idf) {
      if ((this.state.registro.cap_descricao.toUpperCase() === 'PENDENTE') || (this.state.registro.cap_descricao.toUpperCase() === 'ENTREGUE') || (this.state.registro.cap_descricao.toUpperCase() === 'PRODUÇÃO')) {
        Modal.warning({ title: 'Aviso!', content: 'Descrição não permitida' });
        return;
      }
    }

    const reg = {
      cap_idf: this.state.registro.cap_idf,
      cap_descricao: this.state.registro.cap_descricao,
      cap_cor: this.state.registro.cap_cor.key,
    }

    this.props.onSalvarClick(reg);
  };

  render() {
    const { onCancelarClick, carregando, visivel } = this.props;
    const { cap_idf, cap_descricao, cap_cor } = this.state.registro;

    // console.log('CategoriaAnaliseProducaoForm.this.state: ', this.state);

    return (
      <Modal
        title={cap_idf ? "Edição de Categoria da Análise Produção" : "Cadastro de Categoria da Análise de Produção"}
        visible={visivel}
        destroyOnClose
        onCancel={onCancelarClick}
        footer={null}
        width={"40%"}
        style={{ top: 30 }}
      >
        <Form>
          <Row>
            <Col xs={24} sm={24} className="camposEspacoDireita">
              <span>Descrição</span>
              <InputForm
                id="cap_descricao"
                ref="cap_descricao"
                maxLength={15}
                onChange={this.onChange}
                value={cap_descricao}
                validator={value => Boolean(value)}
                disabled={cap_descricao === 'PENDENTE' || cap_descricao === 'ENTREGUE' || cap_descricao === 'PRODUÇÃO'}
              />
            </Col>
            <Col xs={24} sm={24} >
              <span>Cores</span>
              <InputForm
                type="select"
                id="cap_cor"
                ref="cap_cor"
                value={cap_cor}
                placeholder="Selecione"
                onChange={this.onChange}
                data={OPCOES_COR}
                validator={value => Boolean(value)}
                style={{ width: "100%" }}
              />
            </Col>
          </Row>
          <ItemForm>
            <Row>
              <Col xs={24}>
                <Button
                  type="primary"
                  htmlType="button"
                  loading={carregando}
                  onClick={this.onOK}
                  className="botoesModalForm"
                >
                  Salvar
                </Button>

                <Button
                  htmlType="button"
                  onClick={onCancelarClick}
                  className="botoesModalForm"
                >
                  Cancelar
                </Button>
              </Col>
            </Row>
          </ItemForm>

        </Form>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/CategoriaAnaliseProducaoForm.js